
import { defineComponent, PropType, toRaw } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { DispatcherOrderWithoutAddressT } from '@/core/types/dispatcher.types'

// enums
import { DispatcherOrderStatusesEnum } from '@/core/enums/dispatcher.enums'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<DispatcherOrderWithoutAddressT>,
            default: null,
        },
        setDisabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['set-address'],
    setup(props, { emit }) {
        const emitSetAddress = () => {
            if (props.setDisabled) return
            emit('set-address', toRaw(props.item))
        }

        return { DispatcherOrderStatusesEnum, emitSetAddress }
    },
})
